import { HStack, Image, type StackProps, Text } from '@chakra-ui/react';
import { Token } from '@ui/config/token';

import { useH2SwapForm } from './useH2SwapForm';

export const H2BuySellToggle = (props: StackProps) => {
  const fromToken = useH2SwapForm((s) => s.fromToken);
  const isSell = fromToken === Token.Agent;

  return (
    <HStack
      minW="min(223px, 100%)"
      h="48px"
      justifyContent="center"
      p="4px"
      rounded="full"
      bgColor="text.default"
      position="relative"
      textStyle="cta"
      cursor="pointer"
      css={{
        '& *': {
          transition: 'all 0.2s',
        },
      }}
      {...props}
    >
      <Image
        src="/images/switch-indicator.svg"
        boxSize="40px"
        alt="buy sell toggle"
        position="absolute"
        top="4px"
        left={!isSell ? '4px' : 'calc(100% - 44px)'}
        pointerEvents="none"
      />
      <HStack
        w="50%"
        pl={!isSell ? '48px' : '12px'}
        onClick={() => {
          useH2SwapForm.getState().switchTokenPair('buy-agent');
        }}
      >
        <Text color={isSell ? 'text.secondary' : 'background.offWhite'}>
          Buy
        </Text>
      </HStack>
      <HStack
        w="50%"
        pr={isSell ? '48px' : '12px'}
        justifyContent="flex-end"
        onClick={() => {
          useH2SwapForm.getState().switchTokenPair('sell-agent');
        }}
      >
        <Text color={isSell ? 'background.offWhite' : 'text.secondary'}>
          Sell
        </Text>
      </HStack>
    </HStack>
  );
};
